import React from 'react';
import './index.css';
import 'react-calendar/dist/Calendar.css';
import { Item } from '../../types';
import { formatHours, limitText } from '../../utils';


const ScheduleItem = ({ item, urlContext }: { item: Item, urlContext: string | null }) => {
    return (
        <a className='psp-schedule-item' href={`/${urlContext}l/${item.id}`}>
            {formatHours(item.startDate) !== "00:00" && <span className='psp-schedule-item-hours'>{formatHours(item.startDate)}</span>}
            <div className='text-left'>
                <span className='psp-schedule-item-title'>{item.title}</span>
                <span className='psp-schedule-item-location'>Local: {item.location}</span>
            </div>
        </a>
    );
}

export default ScheduleItem
